import { Component, Input, Output, EventEmitter, ViewChild, AfterViewInit } from '@angular/core';
import { FormsModule, NgModel } from '@angular/forms';

import { StatesWebApi } from "../Service/WebApi/StatesWebApi";
import { StatesModel } from "../Models/Model/StatesModel";
import { formService } from '../Service/formService';

@Component({
  selector: 'states',
  templateUrl: 'States.component.html',
  styleUrls: ['States.component.css'],
  providers: [StatesWebApi],
  imports: [FormsModule],
  exportAs: 'ngModel',
})
export class StatesComponent implements AfterViewInit {
  @ViewChild('stateCtrl', { static: false }) stateCtrl?: NgModel;

  public stateId: string | null | undefined;

  /** Form-control validity snapshot (based on ngModel status in this component) */
  public valid: boolean | null | undefined;
  public invalid: boolean | null | undefined;

  // Getter/Setter for the state (same outward API as before)
  @Input()
  get state(): string | null | undefined {
    return this.stateId ?? 'WV';
  }
  set state(stateid: string | null | undefined) {
    if (stateid !== this.stateId) {
      if (stateid) {
        this.stateId = stateid;
      }
      else {
        this.stateId = 'WV';
      }
      this.stateChange.emit(this.stateId);
    }
  }

  @Input() required: boolean = false;
  @Input() disabled: boolean = false;

  @Output() stateChange: EventEmitter<string> = new EventEmitter<string>();

  public states: Array<StatesModel> = [];
  
  constructor(
    private statesWebApi: StatesWebApi,
    private FormService: formService
  ) { }

  ngOnInit() {
    this.statesWebApi.list().subscribe(
      (data) => {
        this.states = data;
      });
  }

  ngAfterViewInit() {
    // Track validity using NgModel’s statusChanges (no ChangeDetectorRef hacks)
    this.stateCtrl?.statusChanges?.subscribe(() => {
      this.valid = this.stateCtrl?.valid ?? null;
      this.invalid = this.stateCtrl ? !this.stateCtrl.valid : null;
    });
  }

  /** Preserve your dynamic width calculation */
  popupWidth = (array: Array<any>, property: string) => {
    return this.FormService.popupWidth(array, property);
  }
}
